import React, { useEffect, memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { userPropTypes } from 'helpers/propTypes';

import Avatar from '@material-ui/core/Avatar';
import ShoppingCart from '@material-ui/icons/ShoppingCart';

import Input from 'components/commons/Input';
import Button from 'components/commons/Button';
import Select from 'components/commons/Select';

import { getProvinces } from 'services/user.services';
import { MINIMUM_PURCHASE_DELIVERY_FREE } from 'constants/configs';

import mercadoPagoImage from 'views/Checkout/assets/mercado-pago.png';
import {
  DELIVERY_FREE, DELIVERY_PAY, DELIVERY_FREE_PAY, DELIVERY_PAY_INTERIOR,
} from '../PaymentForm/constants';

import './DeliveryForm.scss';

const validate = (values) => {
  const errors = {};
  if (!values.first_name) {
    errors.first_name = 'Nombre inválido';
  }
  if (!values.last_name) {
    errors.last_name = 'Apellido inválido';
  }
  if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Dirección de email inválida';
  }
  if (!values.id_card || !/^[0-9]*$/i.test(values.id_card)) {
    errors.id_card = 'DNI inválido';
  }
  if (!values.phone || !/^[0-9]*$/i.test(values.phone)) {
    errors.phone = 'Número inválido';
  }
  if (!values.locality) {
    errors.locality = 'Localidad inválida';
  }
  if (!values.province) {
    errors.province = 'Provincia inválida';
  }
  return errors;
};

const DeliveryForm = (props) => {
  const {
    handleSubmit, initialize, onSubmit, submitting, user, deliveryMethod, setDeliveryMethod,
    couponText, setCouponText, onSubmitCoupon, coupon, emailComplete,
    setEmailComplete, validationEmailCoupon, setEmailCoupon, onSecureCheckoutClick,
    showMPButton,
  } = props;
  const [provinces, setProvinces] = useState([]);

  const options = provinces.map((province) => ({ label: province.name, value: province.name }));

  const callProvinces = async () => {
    try {
      const responce = await getProvinces();
      setProvinces(responce.items);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    callProvinces();
    if (user) {
      initialize({ ...user });
      setEmailComplete(true);
      setEmailCoupon(user.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, setEmailComplete, setEmailCoupon]);

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSubmitCoupon();
    }
  };

  return (
    <div className="container" data-testid="delivery-form">
      <div className="row">
        <div className="form-container">
          <Avatar className="avatar">
            <ShoppingCart />
          </Avatar>
          <h4>Envío a domicilio</h4>
          <form className="redux-form" onSubmit={handleSubmit(onSubmit)}>
            <Field
              component={Input}
              label="Nombre"
              name="first_name"
            />
            <Field
              component={Input}
              label="Apellido"
              name="last_name"
            />
            <Field
              component={Input}
              disabled={!!user}
              label="Email"
              onChange={(event) => validationEmailCoupon(event.target.value)}
              name="email"
            />
            <Field
              component={Input}
              label="DNI"
              name="id_card"
              type="number"
            />
            <Field
              component={Input}
              label="Celular / WhatsApp"
              name="phone"
              type="number"
            />
            <Field
              component={Input}
              label="Dirección, altura y piso"
              name="address"
            />
            <div className="row">
              <Field
                component={Input}
                formGroupClassName="col-sm-6"
                label="Codigo Postal"
                name="postal_code"
              />
              <Field
                component={Input}
                formGroupClassName="col-sm-6"
                label="Localidad"
                name="locality"
              />
            </div>
            <div>
              <Field
                component={Input}
                label="Aplicar Cupon"
                name="coupon"
                disabled={!!coupon || !emailComplete}
                value={couponText}
                onChange={(event) => setCouponText(event.target.value)}
                onKeyPress={onKeyPress}
              />
              <Button
                buttonClass={!coupon ? 'btn-search-set' : 'btn-search-reset'}
                disabled={!emailComplete}
                text={
                    !coupon ? ' Aplicar Cupon ' : <i className="fa fa-trash-o" aria-hidden="true" />
                  }
                type="button"
                onClick={onSubmitCoupon}
              />
            </div>
            <Field label="Provincia" name="province" component={Select} options={options} />
            <Field
              component={Input}
              label="Desea recibir novedades"
              name="suscribe"
              type="checkbox"
            />
            <div className="metodos-envio">
              <h4>Elegí un método de envío</h4>
            </div>
            <div className="checkout-radio-container">
              <div className="checkout-radio">
                <Field
                  onChange={() => setDeliveryMethod(DELIVERY_PAY)}
                  formGroupClassName={deliveryMethod === DELIVERY_PAY ? 'radio-active' : ''}
                  name="delivery_method"
                  label=""
                  component={Input}
                  type="radio"
                  value={DELIVERY_PAY}
                  renderRadioDiv={() => (
                    <div className="radio-button-info">
                      <div className="radio-button-text">
                        <span className="radio-span">Por expreso</span>
                      </div>
                    </div>
                  )}
                />
              </div>
              <div className="checkout-radio">
                <Field
                  onChange={() => setDeliveryMethod(DELIVERY_PAY_INTERIOR)}
                  formGroupClassName={deliveryMethod === DELIVERY_PAY_INTERIOR ? 'radio-active' : ''}
                  name="delivery_method"
                  label=""
                  component={Input}
                  type="radio"
                  value={DELIVERY_PAY_INTERIOR}
                  renderRadioDiv={() => (
                    <div className="radio-button-info">
                      <div className="radio-button-text">
                        <span className="radio-span">Por correo argentino</span>
                      </div>
                    </div>
                  )}
                />
              </div>
            </div>
            {
              deliveryMethod === DELIVERY_PAY && (
                <Field
                  component={Input}
                  label="Transporte de preferencia / Comentarios"
                  isTextArea
                  name="comments"
                />
              )
            }
            <Button text="Arreglar pago con el vendedor" type="button" onClick={handleSubmit(onSubmit)} buttonClass="button-submit btn-block" disabled={submitting} />
            {showMPButton && (
              <Button
                text={(
                  <div className="secure-checkout-button-content">
                    <img src={mercadoPagoImage} alt="mercado pago" height="18" />
                    {' '}
                    Pagar con Mercado Pago
                  </div>
                )}
                type="button"
                onClick={handleSubmit(onSecureCheckoutClick)}
                buttonClass="btn-block secure-checkout-button"
                disabled={submitting}
              />
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

DeliveryForm.defaultProps = {
  user: null,
  coupon: null,
  deliveryMethod: null,
  couponText: '',
  emailComplete: false,
};

DeliveryForm.propTypes = {
  coupon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
  }),
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  user: userPropTypes,
  couponText: PropTypes.string,
  setCouponText: PropTypes.func.isRequired,
  emailComplete: PropTypes.bool,
  onSubmitCoupon: PropTypes.func.isRequired,
  deliveryMethod: PropTypes.string,
  setDeliveryMethod: PropTypes.func.isRequired,
  setEmailComplete: PropTypes.func.isRequired,
  setEmailCoupon: PropTypes.func.isRequired,
  validationEmailCoupon: PropTypes.func.isRequired,
  onSecureCheckoutClick: PropTypes.func.isRequired,
  showMPButton: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'delivery',
  validate,
})(memo(DeliveryForm));
